import checkAjaxError from '@ott/helper-check-ajax-error';
import superagent from '@ott/superagent';

import { saveUnconfirmedOrdersInLocalStorage } from '../../../helpers/ordersLocalStorage';
import T from '../types';

export default function getOrders() {
  return (dispatch) => {
    return dispatch({
      promise: async () => {
        const response = await superagent.get(`/_avia/reservation/unfinished`).catch((error) => {
          return Promise.reject(checkAjaxError(error));
        });

        const { unfinished: results } = response.body || {};

        if (!results || results.length === 0) {
          return;
        }

        const orders = results
          .filter((order) => {
            return order.type === 'confirm';
          })
          .map((order) => ({
            id: order.id,
            routeKey: order.routeKey,
            reservationEndTime: new Date(order.lastTicketDate).getTime(),
            product: __SOLAR__ ? 'solar-avia' : 'avia',
            type: 'user',
          }));

        saveUnconfirmedOrdersInLocalStorage(orders);

        return Promise.resolve(orders);
      },
      types: [T.GET_ORDERS, T.GET_ORDERS_SUCCESS, T.GET_ORDERS_FAIL],
    });
  };
}
